module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AnalyzeDocument_16"],"path":[{"$":{"d":"M11,8.5a3.53,3.53,0,1,0-1.66,3l3.6,3.6,1.13-1.13-3.6-3.6A3.47,3.47,0,0,0,11,8.5ZM7.5,10.4A1.9,1.9,0,1,1,9.4,8.5,1.9,1.9,0,0,1,7.5,10.4ZM15,4v7.76l-2-2V5L9.3,2H3V14H8.76l2,2H1V0h9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AnalyzeDocument_16.svg
// module id = T4i5
// module chunks = 1